function TrademarkListMoveCtrl($uibModalInstance, data, resource, cmdate, $injector, $scope) {
    var vm = new modalCtrl($uibModalInstance, $injector, 'trademark', 'trademark_id', $scope, data);
    vm.count = data.countLines;
    vm.data = {};


    vm.saveMove = function () {
        let errors = {};
        if (!vm.clientSideValidate(errors, 'data', $('.modal-content'))) return;
        vm.confirm(vm.trans("LANG.CONFIRM_MOVE"), vm.trans("LANG.CONFIRM_THE_CHANGES")).then(response => {
            if (response !== "ok") return;
            let postData = angular.copy(data.searchList);
            postData.changeTo = angular.copy(vm.data);
            KApp.block('.modal-content');
            vm.rest.update({
                url: vm.entity + '/actions/move_trademarks',
                params: {
                    action: 'move_trademarks'
                },
                data: postData,
                success: function (response) {
                    if(response.success){
                        toastr.success(response.message);
                    }else{
                        toastr.error(vm.trans('ERROR_WHILE_SAVING'));
                    }
                    KApp.unblock('.modal-content');
                    vm.close('ok');
                }
            });
        });
    };

    return vm;
}
